import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  DocumentData,
  DocumentSnapshot,
  QueryDocumentSnapshot,
  QuerySnapshot,
} from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class FirestoreService {
  constructor(private firestore: AngularFirestore) {}

  getCollection(colUid: string): Promise<QuerySnapshot<any>> {
    return this.firestore.collection(colUid).get().toPromise();
  }

  getDocument(docUid: string): Promise<DocumentSnapshot<any>> {
    return this.firestore.doc<any>(docUid).get().toPromise();
  }

  setDocument(docUid: string, document: DocumentData): Promise<void> {
    return this.firestore.doc<any>(docUid).set(document);
  }

  updateDocument(docUid: string, data: Partial<DocumentData>): Promise<void> {
    return this.firestore.doc<any>(docUid).update(data);
  }

  deleteDocument(docUid: string): Promise<void> {
    return this.firestore.doc<any>(docUid).delete();
  }
}
